module.exports = __webpack_public_path__ + "static/media/sync.fail.9db25f0c.svg";